import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";

export default function NotFound() {
  return (
    <section data-testid="not-found" className="min-h-[80vh] bg-ink text-white flex items-center">
      <Seo title="Page not found | Austyle Plumbing" description="This page doesn't exist." />
      <div className="container-x pt-32">
        <p className="eyebrow text-brass">404</p>
        <h1 className="font-wide font-black uppercase text-5xl sm:text-7xl mt-4">Wrong pipe.</h1>
        <Link to="/" data-testid="not-found-home" className="mt-8 inline-flex bg-brass text-ink font-bold h-12 px-6 items-center rounded-full">Back home</Link>
      </div>
    </section>
  );
}
